import { BrowserRouter, Routes, Route } from "react-router-dom";

import { NotFound } from "./errors/not-found";
import { HomePage } from "./pages/home/home";
import { Playground } from "./pages/playground/homepage";
import { FontTrials } from "./pages/playground/fonts";
import { Carousels } from "./pages/playground/carousels";
import { ExamsTimeTable } from "./pages/playground/exams";
import { PersonalTimeTable } from "./pages/playground/timetable";
import { PersonnelPage } from "./pages/developers/developers";
import { WebDevelopMent } from "./pages/services/web-development";
import { MobileDevelopMent } from "./pages/services/mobile-development";
import { GraphicsDesign } from "./pages/services/graphics-design";
import { CyberSecurity } from "./pages/services/cyber-security";
import ScrollToTopButton from "./components/utilities/to-top-btn";
import { AuthenticationContextProvider } from "./services/authentication/authentication.context";


import "./index.css";
import "./styles/header.css";
import "./styles/rnd-nav.css";
import "./styles/home.css";
import "./styles/exams.css";
import "./styles/fonts.css";
import "./styles/rnd-nav.css";
import "./styles/t-table.css";
import "./styles/slides.css";
import "./styles/nav.css";
import "./styles/personnel.css";
import "./styles/services.css";
import { UserLogin } from "./pages/auth/login";
import { AdminPage } from "./pages/auth/admin";
import ProtectedRoute from "./components/auth/protected";
import { WebsitePortfolio } from "./pages/portfolios/websites";


function App() {
  return (
    <BrowserRouter>
      <AuthenticationContextProvider>
        <ScrollToTopButton />
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/playground/fonts" element={<FontTrials />} />
          <Route path="/playground/carousels" element={<Carousels />} />
          <Route path="/playground/exams" element={<ExamsTimeTable />} />
          <Route path="/playground/timetable" element={<PersonalTimeTable />} />
          <Route path="/playground" element={<Playground />} />
          <Route path="/personnel" element={<PersonnelPage />} />
          <Route path="/enteradmin" element={<UserLogin />} />
          <Route path="/portfolio">
            <Route path="websites" element={<WebsitePortfolio />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route path="/randadmin" element={<AdminPage />} />
          </Route>
          <Route path="/services">
            <Route path="web-development" element={<WebDevelopMent />} />
            <Route path="mobile-development" element={<MobileDevelopMent />} />
            <Route path="graphics-design" element={<GraphicsDesign />} />
            <Route path="cyber-security" element={<CyberSecurity />} />
          </Route>
        </Routes>
      </AuthenticationContextProvider>
    </BrowserRouter>
  )
}

export default App;
